import React, { useEffect, useState } from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { TabView, TabPanel } from 'primereact/tabview';
import { Menubar } from 'primereact/menubar';
import { Calendar } from 'primereact/calendar';
import '../../index.css';

const Cupcakes = ({ cupcakes, productProperties, editable, employees, removeCupcakes, handleCupcakesChange }) => {
  const handleDropdownChange = (e, index, key) => {
    const newCupcakes = [...cupcakes];
    newCupcakes[index] = { ...newCupcakes[index], [key]: e.value };
    handleCupcakesChange(index, newCupcakes[index]);
  };

  const handleInputChange = (event, index, key) => {
    const value = event.target.value;
    const newCupcakes = [...cupcakes];
    newCupcakes[index] = { ...newCupcakes[index], [key]: value };
    handleCupcakesChange(index, newCupcakes[index]);
  };

  const actionTemplate = (rowData, column) => {
    return (
      <Button
        icon="pi pi-trash"
        className="p-button-rounded p-button-danger"
        onClick={() => removeCupcakes(column.rowIndex)}
      />
    );
  };

  const getEmployeesByRole = (role) => {
    return employees
      .filter((employee) => employee.roles.includes(role))
      .map((employee) => ({ label: employee.name, value: employee.name }));
  };

  const flavorOptions = [{ label: 'None', value: null }, ...productProperties[0]?.flavors?.cakes?.sort().map((cake) => ({ label: cake, value: cake }))];
  const fillingOptions = [{ label: 'None', value: null }, ...productProperties[0]?.flavors?.fillings?.sort().map((filling) => ({ label: filling, value: filling }))];
  const icingOptions = [{ label: 'None', value: null }, ...productProperties[0]?.flavors?.icings?.sort().map((icing) => ({ label: icing, value: icing }))];



  const items = () => [
    {
      label: 'Add Topper',
      icon: 'pi pi-fw pi-file',
      //command: () => handleAddTopper(index, tempCake?.toppers?.length ?? 0),
    },
    {
      label: 'Add Decoration',
      icon: 'pi pi-fw pi-file',
      //command: () => handleAddDecoratingItem(index, tempCake?.decoratingItems?.length ?? 0),
    },
  ];


  return (
    <>
      {/* {editable && <Menubar model={items()} />} */}
      <DataTable value={cupcakes} size="small" editMode="cell">
        {editable || cupcakes.some(cupcake => cupcake.quantity) ?
          <Column
            field="quantity"
            header="Quantity"
            editor={editable ? (props) => (
              <InputText
                value={cupcakes[props.rowIndex]?.quantity}
                onChange={(e) =>
                  handleInputChange(e, props.rowIndex, 'quantity')
                }
              />
            ) : null}
          />
          : null}
        {editable || cupcakes.some(cupcake => cupcake.flavor) ?
          <Column
            field="flavor"
            header="Flavor"
            editor={editable ? (props) => (
              <Dropdown
                value={props.rowData['flavor']}
                options={flavorOptions}
                onChange={(e) =>
                  handleDropdownChange(e, props.rowIndex, 'flavor')
                }
                filter
              />
            ) : null}
          />
          : null}
        {editable || cupcakes.some(cupcake => cupcake.description) ?
          <Column
            field="description"
            header="Description"
            editor={editable ? (props) => (
              <InputText
                value={cupcakes[props.rowIndex]?.description}
                onChange={(e) =>
                  handleInputChange(e, props.rowIndex, 'description')
                }
              />
            ) : null}
          />
          : null}
        {editable || cupcakes.some(cupcake => cupcake.filling) ?
          <Column
            field="filling"
            header="Filling"
            editor={editable ? (props) => (
              <Dropdown
                value={props.rowData['filling']}
                options={fillingOptions}
                onChange={(e) =>
                  handleDropdownChange(e, props.rowIndex, 'filling')
                }
                filter
              />
            ) : null}
          />
          : null}
        {editable || cupcakes.some(cupcake => cupcake.finalIcing) ?
          <Column
            field="finalIcing"
            header="Final Icing"
            editor={editable ? (props) => (
              <Dropdown
                value={props.rowData['finalIcing']}
                options={icingOptions}
                onChange={(e) =>
                  handleDropdownChange(e, props.rowIndex, 'finalIcing')
                }
                filter
              />
            ) : null}
          />
          : null}
        {editable || cupcakes.some(cupcake => cupcake.finalIcingColor) ?
          <Column
            field="finalIcingColor"
            header="Final Icing Color"
            editor={editable ? (props) => (
              <InputText
                value={cupcakes[props.rowIndex]?.finalIcingColor}
                onChange={(e) =>
                  handleInputChange(e, props.rowIndex, 'finalIcingColor')
                }
              />
            ) : null}
          />
          : null}
        {editable || cupcakes.some(cupcake => cupcake.decoratingNotes) ?
          <Column
            field="decoratingNotes"
            header="Decorating Notes"
            editor={editable ? (props) => (
              <InputText
                value={cupcakes[props.rowIndex]?.decoratingNotes}
                onChange={(e) =>
                  handleInputChange(e, props.rowIndex, 'decoratingNotes')
                }
              />
            ) : null}
          />
          : null}
        {editable || cupcakes.some(cupcake => cupcake.price) ?
          <Column
            field="price"
            header="Price"
            editor={editable ? (props) => (
              <InputText
                value={cupcakes[props.rowIndex]?.price}
                onChange={(e) =>
                  handleInputChange(e, props.rowIndex, 'price')
                }
              />
            ) : null}
          />
          : null}
        {editable && (
          <Column
            body={actionTemplate}
            style={{ textAlign: 'center', width: '8em' }}
          />
        )}
      </DataTable>

    </>
  );
};

const Topper = ({ toppers, productProperties, editable, onRemove, onChange, getEmployeesByRole }) => {
  const [description, setDescription] = useState('');
  const [type, setType] = useState('');
  const [assignedPerson, setAssignedPerson] = useState('');
  const [dueDate, setDueDate] = useState(new Date());
  const topperTypes = productProperties[0].toppers.types;

  return (
    <div>
      <div style={{ marginBottom: '10px' }}>
        <span className="text-xl text-900 font-bold">Topper Details</span>
      </div>
      <DataTable value={toppers} size={"small"} style={{ width: '100%' }} showGridlines stripedRows >
        <Column
          field="description"
          header="Description"
          editor={editable ? (props) => (
            <InputText
              value={toppers[props.rowIndex]?.description}
              onChange={(e) => {
                setDescription(e.value);
                onChange(props.rowIndex, 'description', e.target.value);
              }}
            />
          ) : null}
        />
        <Column
          field="type"
          header="Type"
          editor={editable ? (props) => (
            <Dropdown
              value={props.rowData.type}
              options={topperTypes.sort()}
              onChange={(e) => {
                setType(e.value);
                onChange(props.rowIndex, 'type', e.value);
              }}
              filter
            />
          ) : null}
        />
        <Column
          field="assignedPerson"
          header="Assigned Person"
          editor={editable ? (props) => (
            <Dropdown
              value={props.rowData.assignedPerson}
              options={getEmployeesByRole('Toppers').sort()}
              onChange={(e) => {
                setAssignedPerson(e.value);
                onChange(props.rowIndex, 'assignedPerson', e.value);
              }}
              filter
            />
          ) : null}
        />
        <Column
          field="dueDate"
          header="Due Date"
          body={(rowData) => rowData.dueDate ? new Date(rowData.dueDate).toLocaleDateString() : ''}
          editor={editable ? (props) => (
            <Calendar
              value={props.rowData.dueDate}
              onChange={(e) => {
                setDueDate(e.value);
                onChange(props.rowIndex, 'dueDate', e.value.toISOString());
              }}
            />
          ) : null}
        />
        {editable && (
          <Column
            body={(rowData, rowIndex) => (
              <div className="p-d-flex p-justify-end">
                <Button
                  icon="pi pi-trash"
                  className="p-button-rounded p-button-danger"
                  onClick={() => onRemove(rowIndex.rowIndex)}
                />
              </div>
            )}
            style={{ textAlign: 'center', width: '8em' }}
          />
        )}
      </DataTable>
    </div>
  );
};

const DecoratingItem = ({ decoratingItems, productProperties, editable, onRemove, onChange, getEmployeesByRole }) => {
  const [description, setDescription] = useState('');
  const [type, setType] = useState('');
  const [assignedPerson, setAssignedPerson] = useState('');
  const [dueDate, setDueDate] = useState(new Date());
  const [price, setPrice] = useState(0);
  const decorationTypes = productProperties[0].decorations.types;

  return (
    <div>
      <div style={{ marginBottom: '10px' }}>
        <span className="text-xl text-900 font-bold">Decorating Items</span>
      </div>
      <DataTable value={decoratingItems} size={"small"} style={{ width: '100%' }} showGridlines stripedRows >
        <Column
          field="description"
          header="Description"
          editor={editable ? (props) => (
            <InputText
              value={decoratingItems[props.rowIndex]?.description}
              onChange={(e) => {
                setDescription(e.value);
                onChange(props.rowIndex, 'description', e.target.value);
              }}
            />
          ) : null}
        />
        <Column
          field="type"
          header="Type"
          editor={editable ? (props) => (
            <Dropdown
              value={props.rowData.type}
              options={decorationTypes.sort()}
              onChange={(e) => {
                setType(e.value);
                onChange(props.rowIndex, 'type', e.value);
              }}
              filter
            />
          ) : null}
        />
        <Column
          field="assignedPerson"
          header="Assigned Person"
          editor={editable ? (props) => (
            <Dropdown
              value={props.rowData.assignedPerson}
              options={getEmployeesByRole('Decorator').sort()}
              onChange={(e) => {
                setAssignedPerson(e.value);
                onChange(props.rowIndex, 'assignedPerson', e.value);
              }}
              filter
            />
          ) : null}
        />
        <Column
          field="dueDate"
          header="Due Date"
          body={(rowData) => rowData.dueDate ? new Date(rowData.dueDate).toLocaleDateString() : ''}
          editor={editable ? (props) => (
            <Calendar
              value={props.rowData.dueDate}
              onChange={(e) => {
                setDueDate(e.value);
                onChange(props.rowIndex, 'dueDate', e.value.toISOString());
              }}
            />
          ) : null}
        />
        <Column
          field='price'
          header='Price'
          editor={editable ? (props) => (
            <InputText
              value={decoratingItems[props.rowIndex]?.price}
              onChange={(e) => {
                setPrice(e.value);
                onChange(props.rowIndex, 'price', e.target.value);
              }}
            />
          ) : null}
        />
        {editable && (
          <Column
            body={(rowData, rowIndex) => (
              <div className="p-d-flex p-justify-end">
                <Button
                  icon="pi pi-trash"
                  className="p-button-rounded p-button-danger"
                  onClick={() => onRemove(rowIndex.rowIndex)}
                />
              </div>
            )}
            style={{ textAlign: 'center', width: '8em' }}
          />
        )}
      </DataTable>
    </div>
  );
};

export default Cupcakes;
